import { createTheme } from '@mui/system';
import { RDSDarkTheme, RDSLightTheme } from '@roku-web-ui/rds-theme';

// Workaround to revert back to RDS MuiSvgIcon behaviour in version 10.0.2
delete RDSDarkTheme?.components?.MuiSvgIcon;
delete RDSLightTheme?.components?.MuiSvgIcon;

export const SmartHomeDarkTheme = createTheme(RDSDarkTheme);
export const SmartHomeLightTheme = createTheme(RDSLightTheme);
